export enum TrackEvents {
  UNKNOWN_PRODUCT = 'UNKNOWN_PRODUCT',
  INACTIVE_PRODUCT = 'INACTIVE_PRODUCT',
  PLUGIN_IMPORTED = 'PLUGIN_IMPORTED',
  PLUGIN_OPENED = 'PLUGIN_OPENED',
  TABLE_OPENED = 'TABLE_OPENED',
  ANALYSIS_DONE = 'ANALYSIS_DONE',
  RECOMMENDATION_DONE = 'RECOMMENDATION_DONE',
  ADD_TO_CART = 'ADD_TO_CART',
  ORDER = 'ORDER',
  SIMILARITY_RECOMMENDATION_VIEW = 'SIMILARITY_RECOMMENDATION_VIEW',
  SIMILARITY_RECOMMENDATION_CLICK = 'SIMILARITY_RECOMMENDATION_CLICK',
  COMPLEMENTARY_RECOMMENDATION_VIEW = 'COMPLEMENTARY_RECOMMENDATION_VIEW',
  COMPLEMENTARY_RECOMMENDATION_CLICK = 'COMPLEMENTARY_RECOMMENDATION_CLICK',
  RETURN_ORDER = 'RETURN_ORDER',
}
